import { ServiceType } from "../../../../features/Booking-Form/typings/booking-service-administration.types";
import { OrderRequestData } from "../Domain/RemoteOrderRequests.types";
import { isResourceOrderRequest } from "./resolveOrderRequestBookingType.function";

export function orderRequestMatchesCateringFilter(item: OrderRequestData): boolean {
  return item.numberOfCaterings > 0 || item.resourceKind === "catering";
}

export function orderRequestMatchesEquipmentFilter(item: OrderRequestData): boolean {
  return item.numberOfBookableEquipments > 0 || item.resourceKind === "equipment";
}

export function orderRequestMatchesServiceTypeFilter(
  item: OrderRequestData,
  type: ServiceType
): boolean {
  switch (type) {
    case ServiceType.Catering:
      return orderRequestMatchesCateringFilter(item);
    case ServiceType.Bookable_Equipment:
      return orderRequestMatchesEquipmentFilter(item);
    case ServiceType.Room_Layout:
      return item.numberOfRoomLayouts > 0;
    default:
      return false;
  }
}

export function countOrderRequestCateringFilterItems(data: OrderRequestData[]): number {
  return data.reduce((sum, item) => {
    if (isResourceOrderRequest(item) && item.resourceKind === "catering") {
      return sum + 1;
    }
    return sum + item.numberOfCaterings;
  }, 0);
}

export function countOrderRequestEquipmentFilterItems(data: OrderRequestData[]): number {
  return data.reduce((sum, item) => {
    if (isResourceOrderRequest(item) && item.resourceKind === "equipment") {
      return sum + 1;
    }
    return sum + item.numberOfBookableEquipments;
  }, 0);
}
